var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 497 497",
    height: 512,
    viewBox: "0 0 497 497",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m248.767 13.222 114.523 193.826 32.462-15.16c1.797-9.281 2.749-18.864 2.749-28.669 0-82.754-67.014-149.853-149.734-149.997z",
    fill: "#077ccc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m248.767 13.222c-.089 0-.177-.003-.266-.003-82.843 0-150.001 67.158-150.001 150.001 0 9.806.952 19.388 2.748 28.669l147.254 68.766 114.789-53.607c3.384-13.865 5.21-28.58 5.21-43.829-.001-82.732-53.583-149.816-119.734-149.997z",
    fill: "#09a1e5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m395.752 191.888h-48.754v291.893c82.844 0 150.002-67.158 150.002-150.001 0-65.775-42.338-121.656-101.248-141.892z",
    fill: "#ff3187"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m394.844 196.189-146.345 55.7v195.017c26.352 22.964 60.8 36.875 98.5 36.875 66.274 0 120.001-67.158 120.001-150.001.001-61.583-29.693-114.488-72.156-137.591z",
    fill: "#ff5178"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m347 183.78 47.845 12.408c.32-1.427.629-2.858.908-4.301-15.287-5.25-31.686-8.107-48.753-8.107z",
    fill: "#622876"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m347 183.78c-37.699 0-72.146 13.911-98.499 36.875l48.753 84.456c48.761-16.751 86.151-57.93 97.59-108.922-14.659-7.976-30.836-12.409-47.844-12.409z",
    fill: "#962b7c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m150.032 483.781c37.687-.008 72.122-13.917 98.467-36.874v-27.438z",
    fill: "#ffb24a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m248.499 419.468v-167.579l-147.252-60c-58.908 20.237-101.247 76.118-101.247 141.892 0 82.843 67.157 150 150 150 40.806-.013 76.821-25.45 98.499-64.313z",
    fill: "#ffd23b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m248.501 220.655c-26.352-22.964-60.801-36.875-98.5-36.875l98.5 67.433z",
    fill: "#49b296"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m150.001 183.78c-17.068 0-33.467 2.857-48.754 8.109 10.254 52.973 48.372 96.004 98.499 113.223l37.807-73.898c-21.893-29.19-53.016-47.433-87.552-47.434z",
    fill: "#89c247"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m297.254 305.111c-9.143 3.141-18.687 5.418-28.531 6.746l-31.167 124.489c3.469 3.699 7.119 7.227 10.943 10.559 31.557-27.499 51.503-67.982 51.503-113.126 0-9.805-.952-19.387-2.748-28.668z",
    fill: "#ff7169"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m268.723 311.858c-6.615.893-13.364 1.362-20.223 1.362-17.068 0-33.467-2.857-48.753-8.108-1.797 9.281-2.749 18.863-2.749 28.669 0 39.672 15.407 75.741 40.558 102.565 20.12-26.825 32.447-62.893 32.447-102.565-.001-7.448-.442-14.766-1.28-21.923z",
    fill: "#ff9259"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m248.501 220.655c-3.825 3.333-7.479 6.858-10.947 10.558l31.169 80.644c9.844-1.329 19.388-3.605 28.531-6.746-6.474-33.446-24.052-62.93-48.753-84.456z",
    fill: "#2d2570"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m199.747 305.112c15.286 5.251 31.685 8.108 48.753 8.108 6.859 0 13.608-.469 20.223-1.362-3.628-30.966-14.825-58.855-31.169-80.644-18.932 20.194-32.336 45.631-37.807 73.898z",
    fill: "#2d3e53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColour);
export default __webpack_public_path__ + "static/media/colour.52d0936341b6f936a29f7211aa61614d.svg";
export { ForwardRef as ReactComponent };